import init from './init'
import get from './get'
import set from './set'
import create from './create'
import remove from './remove'
import removeFiles from './removeFiles'
import removeUsers from './removeUsers'
import setDefaultAvatar from './setDefaultAvatar'

export default {
  ...init,
  ...get,
  ...set,
  ...create,
  ...remove,
  ...removeFiles,
  ...removeUsers,
  ...setDefaultAvatar
}
